[
  {
    "locale": "es-ES",
    "space": "4gsr0wtgbzc1",
    "accessToken": "H3qQV8x9B4llUCFx3FVaLs8Ldq4f1bJWUY--aZB8c0E"
  }
]